import { render, staticRenderFns } from "./MedicalEvaluationForm.vue?vue&type=template&id=a8f1d3b0&"
import script from "./MedicalEvaluationForm.vue?vue&type=script&lang=js&"
export * from "./MedicalEvaluationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports